function normalizePath(path) {
    const normalized = path.replace(/\/+$/, '');
    return normalized || '/';
}

function initializePublicShell(root = document) {
    const page = root.querySelector('.us-public-page');
    if (!page || page.dataset.usEnhanced === 'true') {
        return;
    }

    page.dataset.usEnhanced = 'true';
    const currentPath = normalizePath(window.location.pathname);

    for (const link of page.querySelectorAll('nav a[data-href]')) {
        const expectedPath = normalizePath(link.dataset.href || '');
        if (currentPath === expectedPath || currentPath.endsWith(expectedPath)) {
            link.setAttribute('aria-current', 'page');
        }
    }

    window.baguetteBox?.run?.('.gallery');
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializePublicShell(), { once: true });
} else {
    initializePublicShell();
}

export { initializePublicShell, normalizePath };
